import { render, staticRenderFns } from "./NotifySend.vue?vue&type=template&id=290bddf4&scoped=true"
import script from "./NotifySend.vue?vue&type=script&lang=js"
export * from "./NotifySend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290bddf4",
  null
  
)

export default component.exports